import tempMeeApi from '../../../apis/tempMee';

// Every campaign this professional is or has been matched to, newest match
// first (the service orders by matched_at DESC — see GOTU-7046). Read-only,
// CS-facing: there is no admin write side to campaign eligibility.
export const getProfessionalCampaigns = async (professionalId) => {
  const response = await tempMeeApi.get(
    `/campaign-service/v1/admin/professionals/${professionalId}/eligibilities`,
  );

  return response.data;
};
